export const QUADS = [
  { m: "existing", p: "existing", title: "Market Penetration", sub: "Existing market · Existing product", risk: "Lowest risk", head: "bg-emerald-50 border-emerald-200 text-emerald-700" },
  { m: "existing", p: "new", title: "Product Development", sub: "Existing market · New product", risk: "Moderate risk", head: "bg-blue-50 border-blue-200 text-blue-700" },
  { m: "new", p: "existing", title: "Market Development", sub: "New market · Existing product", risk: "Moderate risk", head: "bg-amber-50 border-amber-200 text-amber-700" },
  { m: "new", p: "new", title: "Diversification", sub: "New market · New product", risk: "Highest risk", head: "bg-red-50 border-red-200 text-red-700" },
];

export function AnsoffGrid({ initiatives }) {
  const placed = (initiatives || []).filter((x) => x.name?.trim());
  const at = (q) => placed.filter((x) => (x.market || "existing") === q.m && (x.product || "existing") === q.p);
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="ansoff-grid">
      {QUADS.map((q) => {
        const items = at(q);
        return (
          <div key={q.title} data-testid={`ansoff-quad-${q.title.toLowerCase().replace(/\s/g, "-")}`} className="bg-white border border-slate-200 rounded-sm overflow-hidden">
            <div className={`px-4 py-3 border-b ${q.head} flex items-center justify-between`}>
              <div>
                <p className="font-mono text-sm font-bold uppercase tracking-wide">{q.title}</p>
                <p className="text-xs opacity-80">{q.sub}</p>
              </div>
              <span className="font-mono text-[10px] font-bold uppercase tracking-wide opacity-70 whitespace-nowrap">{q.risk}</span>
            </div>
            <div className="p-4 min-h-[120px]">
              {items.length === 0 ? <p className="text-sm text-slate-300">— None —</p> : (
                <ul className="space-y-2">
                  {items.map((x) => (
                    <li key={x.id} className="flex items-start gap-2 text-sm text-slate-800">
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-slate-400 shrink-0" />
                      <span><span className="font-medium">{x.name}</span>{x.note && <span className="block text-xs text-slate-400">{x.note}</span>}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function AnsoffBlueprint({ doc }) {
  const initiatives = doc.payload?.initiatives || [];
  return (
    <div data-testid="ansoff-blueprint">
      {doc.payload?.context && <p className="mb-6 text-sm text-slate-500 max-w-2xl">{doc.payload.context}</p>}
      <AnsoffGrid initiatives={initiatives} />
      <p className="mt-3 text-xs text-slate-400 font-mono">Risk rises from Market Penetration → Diversification. Diversification demands new products in unfamiliar markets.</p>
    </div>
  );
}
